import { render, staticRenderFns } from "./SlideSection.vue?vue&type=template&id=8ed92a16&scoped=true"
import script from "./SlideSection.vue?vue&type=script&lang=js"
export * from "./SlideSection.vue?vue&type=script&lang=js"
import style0 from "./SlideSection.vue?vue&type=style&index=0&id=8ed92a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed92a16",
  null
  
)

export default component.exports